import HambrMenuSvgToggle from '../UI/HambrMenuSvgToggle';
import LogoSvgToggle from '../UI/LogoSvgToggle';

import classes from './HeaderLeft.module.scss';

export default function HeaderLeft({ toggleSider, isSiderVisible }) {
  return (
    <div className={classes['left-container']}>
      <button
        style={{
          background: 'transparent',
          outline: 'none',
          border: 'none',
        }}
      >
        <HambrMenuSvgToggle
          siderToggled={isSiderVisible}
          handleToggle={toggleSider}
        />
      </button>
      <div>
        <LogoSvgToggle siderToggled={isSiderVisible} />
      </div>
    </div>
  );
}
